/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import notificacionGlobal from '@infotrack/presentacion-componentes/notificacionGlobal';
import ModeloFlujos from 'Infotrack@Modelos/smartStock/flujos';
import IFlujos from 'Infotrack@Modelos/smartStock/flujos/entidades/flujos';

export default class ControladorModeloFlujos {
    private modeloFlujos: ModeloFlujos;
    constructor() {
        this.modeloFlujos = new ModeloFlujos();
    }

    public consultarFlujos() {
        return this.modeloFlujos.consultarFlujos().then(({ data: { Entidades } }) => Entidades);
    }

    public async crearFlujos(flujos: IFlujos) {
        //await this.modeloFlujos.crearFlujos(flujos);
    }

    public async editarFlujos(flujos: IFlujos) {
        //await this.modeloFlujos.editarFlujos(flujos);
    }
    public async eliminarFlujos(flujos: IFlujos) {
        //await this.modeloFlujos.eliminarFlujos(flujos);
    }

    public validarEntidad(flujos: IFlujos): boolean {
        if (flujos.FlujoDescripcion === '') {
            notificacionGlobal('Por favor ingrese todos los campos requeridos (*)', 6000, 'warning', true);
            return false;
        }
        return true;
    }
}
